var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showSubmitButton)?_c('div',{staticClass:"tab-btn-container",class:[_vm.spacingClass]},[_c('button',{staticClass:"tab-btn next submit",class:{
      'tab-visible': _vm.tabsLength > 1,
      'w-100': _vm.layoutSetting?.spacing == 'largemargin',
    },style:(_vm.brandedSubmitBtnStyle),attrs:{"type":"submit","id":"submitBtn"},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('submit', $event)}}},[_vm._v("\n    "+_vm._s(_vm.settings?.btnCaption || 'Starten')+"\n  ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }